import React from 'react';
import RopeQuote from './RopeQuote';

const TestimonialGallery: React.FC = () => {
  return (
    <div className="w-full py-8">
      <RopeQuote
        imageUrl="https://santaplaya-bucket.s3.amazonaws.com/simpler_is_better.webp"
        title="Jared P."
        body={`"As a San Diego native I know a good fish taco I've had hundreds. After moving to sb, there are so many fish tacos around but none of them are authentic, legit, or quality. Seriously name any I've tried it. Santa playa mariscos is where I finally found a Baja fish taco in sb that is made correctly. And for a good price."`}
        imageOnLeft={true}
      />

      <RopeQuote
        imageUrl="https://santaplaya-bucket.s3.amazonaws.com/fresh_seafood_cocktail.webp"
        title="Jasmine R."
        body={`"Food was as great as their service!!! We ordered the shrimp cocktail, it hit the spot! Looking forward to trying more of their menu!"`}
        imageOnLeft={false} // flips to image on the right
      />

      <RopeQuote
        imageUrl="https://santaplaya-bucket.s3.amazonaws.com/mixta.webp"
        title="Missy H."
        body={`"Wow! Very fresh & simply delicious mariscos. We had a 'mixta' tostada (octopus, shrimp & fish ceviche) at one of their little tables outside, since we were walking with our pup. Plenty of room inside. Looks like a fun place to meet up with friends that enjoy some brews or Margaritas with the magnificent food. Delicious salsa & chips & an attentive waiter made the whole experience perfect. We'll be back soon!"`}
        imageOnLeft={true}
      />
    </div>
  );
};

export default TestimonialGallery;
